export const FIRMWARE_MODEL_TO_COMPONENT_MODEL_MAP = {
  SC360: [/^[XT]SYS2C60/],
  XL1050: [/^[TA]ZON1050/],
  XL850: [/^[TA]CONT850/],
  XL824: [/^[TA]CONT824/],
  Pivot: [/^BAYSTAT814/, /^[TA]CONT830/]
}

export const isModelFirmwareStatusReportable = (model: string) => {
  return Object.values(FIRMWARE_MODEL_TO_COMPONENT_MODEL_MAP).some((componentModelRegex) => {
    return componentModelRegex.some((regex) => regex.test(model))
  })
}

export const doesFirmwareModelMatchComponent = (firmwareModel: string, componentModel: string) => {
  const componentModelMatches = FIRMWARE_MODEL_TO_COMPONENT_MODEL_MAP[firmwareModel]

  if (componentModelMatches) {
    return componentModelMatches.some((componentModelRegex) => componentModelRegex.test(componentModel))
  }

  return false
}
